import { EsourceTMSList, EdivisionList, ESOURCE_TYPE_CHECK } from "./constants"

export interface IuploadDocumentTypeList {
  name: string;
  value: string;
  role?: Array<string>;
}
export type IuploadDocumentTypeList_NEW = {
  [key in EUSER_ROLES]?: string[];
}

export enum EUSER_ROLES {
  carrierGuest= "carrierGuest",
  carrierDispatcher= "carrierDispatcher",
  carrierDriver= "carrierDriver",
  carrierAdmin= "carrierAdmin",
  carrierLeasedOwnerOpr= "carrierLeasedOwnerOpr",
  carrierBeta1= "carrierBeta1"
};
export interface ISOURCE_TMS_AND_DIVISION_VALIDATION {
  [ESOURCE_TYPE_CHECK.VIEW_DOCUMENT_ROLE]: EUSER_ROLES[];
  [ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_ROLE]: EUSER_ROLES[];
  [ESOURCE_TYPE_CHECK.INVOICE_UPLOAD_DOCUMENT_ROLE]: EUSER_ROLES[];
  [ESOURCE_TYPE_CHECK.PAYMENT_STATUS_BUTTON_ROLE]: EUSER_ROLES[];
  [ESOURCE_TYPE_CHECK.AVAILABLE_DOCUMENT_SECTION_ROLE]: EUSER_ROLES[];
  [ESOURCE_TYPE_CHECK.RELATED_DOCUMENT_SECTION_ROLE]: EUSER_ROLES[];
  [ESOURCE_TYPE_CHECK.SCHNEIDER_INVOICE_CREATION_SECTION_ROLE]: EUSER_ROLES[];
  [ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_TYPE]: IuploadDocumentTypeList_NEW;
}
export type IGENERAL_DOCUMENT_CONFIG = {
    [key in EsourceTMSList]?: ISOURCE_TMS_CONFIG | null;
}
export type ISOURCE_TMS_CONFIG = {
    [key in EdivisionList]?: ISOURCE_TMS_AND_DIVISION_VALIDATION;
}
export interface IADD_DOCUMENT_CONFIG {
  documentFormat: string,
  maximumSize: number,
  webGalleryButtonTitle : string,
  mobileGalleryButtonTitle : string,
  mobileCameraButtonTitle : string,
  mobileUploadFooterContent : string,
  documentTypeSelectionErrorMessage : string,
  preventDocumentUploadBeforeStartTripErrorMesssage:string,
  noDocumentTypeAvailableMsg:string,
}
interface IFETCH_DOCUMENT_CONFIG {
  failureMessage: string;
}
export interface IUPLOAD_DOCUMENT_CONFIG_FALLBACK {
  GENERAL_DOCUMENT_CONFIG: IGENERAL_DOCUMENT_CONFIG;
  ADD_DOCUMENT_CONFIG: IADD_DOCUMENT_CONFIG;
  FETCH_DOCUMENT_CONFIG: IFETCH_DOCUMENT_CONFIG;
  DOCUMENT_TYPE: {
    [name: string]: {
      name: string;
      value: string;
    }
  }
}
interface OPTIONAL_CONTENT_OR_CONFIG_REQUEST {
  configFilter?: string;
  contentFilter?: string;
}

export interface ICOC_CONTENT_REQUEST
  extends OPTIONAL_CONTENT_OR_CONFIG_REQUEST {
  contentType: string;
}

export interface ICOC_CONFIG_REQUEST
  extends OPTIONAL_CONTENT_OR_CONFIG_REQUEST {
  configTable: string;
}
export interface ICONTENT_OR_CONFIG_RESPONSE {
  "@baseType": string;
  "@type": string;
  configTableName: string;
  output: any[];
}

interface ISTORE_VERSION {
  forceUpdate: boolean;
  forceUpdateMessage: string;
  minimumVersion: string;
  optionalUpdateMessage: string;
  show: boolean;
  title: string;
  version: string;
}

interface ISIMILER_LOADS {
  similarloads_color: string;
}
interface IBOOK_NOW {
  booknow_color: string;
}

interface INON_MANAGED_EQUIPMENT_ALIGNMENT {
  question_alignment: string;
}
interface IDISPATCHER_ERROR_PAGE {
  dispatcher_icon: string;
  dispatcher_message: string;
}
interface IDRIVER_ERROR_PAGE {
  driver_icon: string;
  driver_message: string;
}
interface IAPP_INIT {
  API_HOST: string;
  GEO_PRE_ARRIVAL_RADIUS: number;
  AZURE_PREFERENCE_API_HOST: string;
  AZURE_PREFRENCES_SUBSCRIPTION_KEY: string;
  PCMILER_API_KEY: string;
  NOTIFICATION_API_HOST: string;
  NOTIFICATION_SUBSCRIPTION_KEY: string;
  APPLESTORE_REDIRECTURL: string;
  PLAYSTORE_REDIRECTURL: string;
}

interface IENV_SPECIFIC {
  store_version: ISTORE_VERSION;
  similar_loads: ISIMILER_LOADS;
  book_now: IBOOK_NOW;
  non_manage_equipment_alignment: INON_MANAGED_EQUIPMENT_ALIGNMENT;
  dispatcher_error_page: IDISPATCHER_ERROR_PAGE;
  driver_error_page: IDRIVER_ERROR_PAGE;
  APP_INIT: IAPP_INIT;
}
export interface IPORT_DRAY_CONTACT_DETAILS {
  carrierPhone: string,
  carrierName: string,
  carrierEmail: string,
}
export interface ISHIPMENT_INVLOVED_PARTY {
  id: string,
  partyEmail: string,
  partyId: string,
  partyName: string,
  partyPhone: string,
  partyType: string
}
type IRole = {
  roleId: string,
  roleName: string
}
type IUserApplicationDetail = {
  attributes: {
    requestedRoles: any
  },
  roles: IRole[]
}
export interface IMember {
  "upn": string,
  "firstName": string,
  "lastName": string,
  "companyName": string,
  "email": string,
  "mobileNumber": string,
  "image": string,
  "carrierId": string,
  "carrierName": string,
  "carrier": boolean,
  "tractorNumber": string,
  "registered": boolean,
  "active": boolean,
  "sendEmailInvite": boolean,
  "updatedTimeStamp": string,
  "updatedBy": string,
  "carrierUsDotNo": string,
  "carrierMcNo": string,
  "countryCode": string,
  "userApplicationDetails": IUserApplicationDetail[]
  "address": any[],
  "phoneNumberDetails": any[]
}

export interface LATE_REASONCODE_MODAL_CONFIG {
  [MERGURYGATE: string]: LATE_REASONCODE_SOURCE_TMS_VALIDATION;
   MASTERMIND : LATE_REASONCODE_SOURCE_TMS_VALIDATION;
   OTMNONASSET: LATE_REASONCODE_SOURCE_TMS_VALIDATION;
   TRINIUM : LATE_REASONCODE_SOURCE_TMS_VALIDATION;
}
export interface LATE_REASONCODE_SOURCE_TMS_VALIDATION {
  VISIBILITY: string[];
  GRACE_PERIOD: any;
  REASON_CODES : any;
}